import { L, vocabulary } from '../define.js';
export const OPS_PLATFORM_VOCABULARIES = [
    vocabulary('whatsapp.message_kind', '@vello/whatsapp-adapter MESSAGE_KINDS', {
        text: L('Texto', 'Text', 'Texto', 'Testo'),
        media: L('Mídia', 'Media', 'Multimedia', 'Contenuto multimediale'),
        template: L('Modelo aprovado', 'Approved template', 'Plantilla aprobada', 'Modello approvato'),
        flow: L('Fluxo interativo', 'Interactive flow', 'Flujo interactivo', 'Flusso interattivo'),
    }),
    vocabulary('control_plane.sequence_check', '@vello/control-plane SequenceCheck', {
        apply: L('Aplicar o evento', 'Apply the event', 'Aplicar el evento', 'Applicare l’evento'),
        duplicate: L('Evento repetido', 'Duplicate event', 'Evento duplicado', 'Evento duplicato'),
        gap: L('Evento faltando na sequência', 'Event missing in the sequence', 'Evento faltante en la secuencia', 'Evento mancante nella sequenza'),
    }),
    vocabulary('control_plane.delivery_outcome', '@vello/control-plane DeliveryOutcome', {
        advance_checkpoint: L('Entregue', 'Delivered', 'Entregado', 'Consegnato'),
        retry: L('Nova tentativa', 'Retry', 'Reintento', 'Nuovo tentativo'),
        dead_letter: L('Enviado para a fila de falhas', 'Sent to the failure queue', 'Enviado a la cola de fallos', 'Inviato alla coda dei fallimenti'),
    }),
    vocabulary('fleet.node_role', '@vello/fleet NodeRole', {
        manager: L('Gerenciador', 'Manager', 'Gestor', 'Gestore'),
        worker: L('Trabalhador', 'Worker', 'Trabajador', 'Worker'),
    }),
    vocabulary('fleet.rotation_state', '@vello/fleet RotationState', {
        ok: L('Em dia', 'Up to date', 'Al día', 'In regola'),
        due_soon: L('Vence em breve', 'Due soon', 'Vence pronto', 'In scadenza'),
        overdue: L('Vencido', 'Overdue', 'Vencido', 'Scaduto'),
    }),
    vocabulary('analytics.event_actor', '@vello/analytics EventActor', {
        rider: L('Passageiro', 'Rider', 'Pasajero', 'Passeggero'),
        driver: L('Motorista', 'Driver', 'Conductor', 'Autista'),
        system: L('Sistema', 'System', 'Sistema', 'Sistema'),
        operator: L('Operador', 'Operator', 'Operador', 'Operatore'),
    }),
    vocabulary('location_pipeline.reason', '@vello/location-pipeline LocationHotStore (upsert result), ProcessReason', {
        APPLIED: L('Posição aplicada', 'Position applied', 'Posición aplicada', 'Posizione applicata'),
        STALE_OVERWRITE: L('Posição antiga ignorada', 'Older position ignored', 'Posición antigua ignorada', 'Posizione obsoleta ignorata'),
        OK: L('Posição processada', 'Position processed', 'Posición procesada', 'Posizione elaborata'),
        CONSENT_REQUIRED: L('Falta o consentimento de localização', 'Location consent is missing', 'Falta el consentimiento de ubicación', 'Manca il consenso alla posizione'),
    }),
    vocabulary('driver_loyalty.appeal_state', '@vello/driver-loyalty APPEAL_STATES', {
        OPEN: L('Em aberto', 'Open', 'Abierta', 'Aperta'),
        UPHELD: L('Mantida a nota', 'Score upheld', 'Nota mantenida', 'Valutazione confermata'),
        GRANTED: L('Recurso aceito', 'Appeal granted', 'Apelación aceptada', 'Ricorso accolto'),
    }),
    vocabulary('otp.send_reason', '@vello/otp-delivery OtpSendReason', {
        SENT: L('Código enviado', 'Code sent', 'Código enviado', 'Codice inviato'),
        FAILED: L('Falha no envio do código', 'Code sending failed', 'Falló el envío del código', 'Invio del codice non riuscito'),
        NOT_AUTHORIZED: L('Envio de código não configurado', 'Code sending not set up', 'Envío de código no configurado', 'Invio del codice non configurato'),
    }),
    vocabulary('provider.credential_status', '@vello/secret-vault CredentialStatus', {
        CONFIGURED: L('Configurada', 'Configured', 'Configurada', 'Configurata'),
        UNCONFIGURED: L('Não configurada', 'Not configured', 'No configurada', 'Non configurata'),
    }),
    vocabulary('courier_food.courier_service', '@vello/courier-food COURIER_SERVICES', {
        food: L('Comida', 'Food', 'Comida', 'Cibo'),
        send: L('Envios', 'Send', 'Envíos', 'Spedizioni'),
    }),
];
//# sourceMappingURL=ops-platform.js.map